export default __webpack_public_path__ + "static/media/envelope.2ed4a6a2.svg";